import { where } from 'firebase/firestore';

import { Quote } from '../models';
import { QuoteStatus } from '../enums';
import { useCollection } from './useCollection';
import { useAuthentication, useCurrentUser } from '.';

export function useOutstandingQuoteRequests(currentUserQuotesOnly = false) {
  const user = useCurrentUser();
  const { isAgent, isCorporateUser } = useAuthentication();
  const filters = [
    where('status', 'in', [
      QuoteStatus.Draft,
      QuoteStatus.InProgress,
      QuoteStatus.Submitted,
    ]),
  ];

  if (currentUserQuotesOnly) {
    filters.push(where('customerId', '==', user.id));
  } else if (isAgent) {
    filters.push(where('agencyId', '==', user.companyRef.id));
  } else if (isCorporateUser) {
    filters.push(where('corporateCompanyId', '==', user.companyRef.id));
  } else {
    filters.push(where('companyId', '==', user.companyRef.id));
  }

  return useCollection<Quote>('Quotes', filters);
}
